import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReceptionOrderStatus } from '@euler/model/enum';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const OrderSummaryTitleDecoratorView = memo(
  ({
    status,
    isRollback,
    isFirstTimeOrder,
    style,
  }: {
    status?: ReceptionOrderStatus;
    isFirstTimeOrder?: boolean;
    isRollback?: boolean;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();
    const statusBadgeType =
      status === ReceptionOrderStatus.Cancelled
        ? 'close'
        : isRollback
        ? 'rollback'
        : undefined;

    if (!statusBadgeType && !isFirstTimeOrder) {
      return null;
    }
    return (
      <StackLayout direction="row" alignItems="center" style={style}>
        {isFirstTimeOrder && (
          <Center
            style={style}
            borderWidth={rpx(1.5)}
            borderColor="rgba(109, 184, 34, 1)"
            height={rpx(22)}
            paddingHorizontal={rpx(5)}
            ml={rpx(8)}
            borderRadius={rpx(3)}
            flexDirection="row"
            alignItems="center"
          >
            <Typography.Text
              medium
              size={rpx(13)}
              lineHeight={rpx(18)}
              color="rgba(109, 184, 34, 1)"
            >
              首次进店
            </Typography.Text>
          </Center>
        )}
        {statusBadgeType != null && (
          <Center
            style={style}
            borderWidth={rpx(1.5)}
            borderColor="red"
            height={rpx(22)}
            paddingHorizontal={rpx(5)}
            ml={rpx(8)}
            borderRadius={rpx(3)}
            flexDirection="row"
            alignItems="center"
          >
            <Typography.Text
              medium
              size={rpx(13)}
              lineHeight={rpx(18)}
              color="red"
            >
              {statusBadgeType === 'rollback'
                ? '返单工作中'
                : statusBadgeType === 'close'
                ? '服务已终止'
                : ''}
            </Typography.Text>
          </Center>
        )}
      </StackLayout>
    );
  },
);
